import React from 'react';
import ReactDOM from 'react-dom';
import createSagaMiddleware from 'redux-saga';
import superagent from 'superagent';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import { handleRequests } from '@redux-requests/core';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import * as Sentry from '@sentry/browser';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { createDriver } from './shared/utils/superagent.saga';
import { createDriver as createMockDriver } from '@redux-requests/mock';

import { allFeatureReducers, rootSaga } from './services/app';
import './index.css';
import {createArbiterMiddleware} from './shared/redux-middlewares';

/**
 * Globals
 */
// The App Name as defined in the package.json
export const appName: string = PACKAGE_JSON_PROP.name;

if (process.env.SERVICES_SENTRY_ENABLED) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.__VERSION__,
    environment: process.env.ENV
  });
}

/**
 * REDUX + STORE LOGIC
 */

const sagaMiddleware = createSagaMiddleware();

// Less noisey with collapsed
const loggerMiddleware = createLogger({
  collapsed: true,
    colors: {
      title: () => '#b8dfcf',
      action: () => '#03A9F4',
    }, 
});

// Redux Requests Middleware
const { requestsReducer, requestsMiddleware } = handleRequests(
  { 
    driver: 
    {
      default: createDriver(superagent),
      mock: createMockDriver({timeout: 1000}),  // add - `meta: { driver: 'mock'}` to a request action to use the mock driver
    } 
   }
  );

let middlewares = [loggerMiddleware, sagaMiddleware];

if (CONNECTED_TO_ARBITER) {
  const arbiterMiddleware = createArbiterMiddleware({
    debugMode: false,
    targetOrigin: process.env.REACT_APP_ARBITER_URI,
  });

  middlewares = [arbiterMiddleware].concat(middlewares)
}

const rootReducer = combineReducers({
  ...allFeatureReducers,
  requests: requestsReducer,
})

// The Root State Type for TS, can be removed if not in use
export type RootState = ReturnType<typeof rootReducer>

const composeEnhancers = composeWithDevTools({});
// creating a store for the redux structure
const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(...middlewares, ...requestsMiddleware), //Requests MW goes last
  ),
);

sagaMiddleware.run(rootSaga)

/**
 * MAIN APP RENDER
 */
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app-root')
);

/*
  Globals, access store from console in dev mode
*/
if (process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'development') {
  // @ts-ignore
  window.getState = store.getState;
}

/** CREACT REACT APP LEFTOVER */
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
